<!-- 周销售报表 -->
<template>
    <div id="home">
    	<van-nav-bar
    		v-if="$i18n.locale=='en'"
		  	:title="$t('WeekDetail.week')+' '+$route.query.week"
			left-arrow
			:right-text="$t('DayReport.export')"
			fixed
		  	@click-left="$router.push('/WeekReport')"
		  	@click-right="onClickExport">
		</van-nav-bar>
		<van-nav-bar
			v-else
		  	:title="$t('WeekDetail.text')+$route.query.week+$t('WeekDetail.week')"
			left-arrow
			:right-text="$t('DayReport.export')"
			fixed
		  	@click-left="$router.push('/WeekReport')"
		  	@click-right="onClickExport">
		</van-nav-bar>

		<div class="weekBtn">
			<van-nav-bar
			  :left-text="$t('WeekDetail.prev')"
			  left-arrow
			  @click-left="onClickLeft"
			  @click-right="onClickRight">
				<template #right>
					{{$t('WeekDetail.next')}}
					<van-icon name="arrow" size="22" />
				</template>
			</van-nav-bar>
		</div>

		<div class="chartBox" id="chart"></div>
		<van-cell-group>
			<van-cell>
				<van-row>
			  		<!-- <van-col span="8">{{$t('WeekDetail.date')}}</van-col>
			  		<van-col span="12">{{$t('WeekDetail.peoopleNum')}}</van-col>
			  		<van-col span="4">{{$t('WeekDetail.amountOfMoney')}}({{currency}})</van-col> -->
			  		<van-col span="4">{{$t('WeekDetail.date')}}</van-col>
			  		<van-col span="3">{{$t('WeekDetail.peoopleNum')}}</van-col>
			  		<van-col span="4">Line Pay</van-col>
			  		<van-col span="3">{{$t('payMethod.card')}}</van-col>
			  		<van-col span="3">{{$t('payMethod.cash')}}</van-col>
			  		<van-col span="3">{{$t('payMethod.other')}}</van-col>
			  		<van-col span="4">{{$t('payMethod.totalprice')}} ({{currency}})</van-col>
				</van-row>
				<div slot="right-icon" style="width: 22px;"></div>
			</van-cell>
			<template v-for='(item,index) in weekData'>
				<van-cell  is-link :to="{ path: '/DayReport',query:{year:item.date.substr(0,4),month:item.date.substr(5,2),day:item.date.substr(8,2)}}" >
					<van-row>
				  		<van-col span="4">{{item.date}}</van-col>
				  		<van-col span="3">{{item.number}}</van-col>
				  		<van-col span="4">{{item.line_pay}}</van-col>
				  		<van-col span="3">{{item.card}}</van-col>
				  		<van-col span="3">{{item.price}}</van-col>
				  		<van-col span="3">{{item.other}}</van-col>
				  		<van-col span="4">{{item.total}}</van-col>
					</van-row>
					<!-- <div>{{item.date.substr(0,4)}}</div>
					<div>{{item.date.substr(5,2)}}</div>
					<div>{{item.date.substr(8,2)}}</div> -->
				</van-cell>
			</template>
		</van-cell-group>
    </div>
</template>
<script>
  	export default {
  		data () {
	      	return {
	      		options:{
	      			title: {
				        text: this.$t('WeekDetail.weekReport')
				    },
				    color: ['red'],
				    tooltip: {},
				    // toolbox: {
        //                 feature: {
        //                     saveAsImage: {
        //                     }
        //                 }
        //             },
                    grid: {
                        left: '5%',
                        // right: '4%',
                        bottom: '10%',
                        containLabel: true
                    },
				    xAxis: {
				    	name:this.$t('WeekDetail.day'),
				        data: [],  //横坐标
				    	axisTick: {
			                alignWithLabel: true,
			            },
			            axisLabel:{
			                interval:0
			            }
				    },
				    yAxis: {
				    	name:this.$t('WeekDetail.money'),
				    },
				    series: [{
				        name: this.$t('WeekDetail.amountOfMoney'),
				        type: 'bar',
				        label: {
			                normal: {
			                    show: true,
			                    position: 'top'
			                }
	            		},
				        data: [],  //纵坐标
				    }]
	      		},
	      		weekData:[],
				weekChart:'',	
				currency:'',
				nowDate:(Math.round(new Date().getTime()/1000)),
				prevData:{},
				nextData:{},
				weekList:[],
	      	}
	    },
	    watch: {
	        "$route":{
	        	handler(route){
	        		const that = this;
	        		if(route.name == 'WeekDetail'){
		                that.getWeekData();
				    	that.weekChart=that.$echarts.init(document.getElementById("chart"));
						that.getWeekDetail();
						that.getCurrency();
		            }
	        	},
	        	deep: true
	         }
	    },
	    mounted:function(){
	    	this.getWeekData();
	    	this.weekChart=this.$echarts.init(document.getElementById("chart"));
			this.getWeekDetail();
			this.getCurrency();
	    },
	    methods:{
	    	// 获取周报表
	    	getWeekData(){
				this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/totalWeekIncome',
	                data:{
	                	date:this.nowDate,
	                }
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	            		var weekList = [];
	            		res.data.data.forEach((item,index) => {
	            			item.start = item.startday.split('-').join('/');
	            			item.end = item.endday.split('-').join('/');
	            			weekList.push(item);
	            			if(item.period == this.$route.query.week){
	            				this.prevData = res.data.data[index-1];
	            				this.nextData = res.data.data[index+1];
	            			}
	            		})
	                	this.weekList=weekList;
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	
	            });
	    	},
	    	// 获取周报表细节
	    	getWeekDetail(){
				this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/eachWeekIncome',
	                data:{
	                	startday:this.$route.query.startday,
	                	endday:this.$route.query.endday,
	                }
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	                	this.weekData=res.data.data;
	                	this.options.xAxis.data=res.data.week;
	                	this.options.series[0].data=res.data.price;
	    				this.weekChartInit();
	    				this.startday=this.$route.query.startday
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	
	            });
	    	},
	    	weekChartInit(){
	    		this.weekChart.setOption(this.options);
			},
			// 获取店铺设置的货币
			getCurrency(){
				this.$axios({
					method: 'get',
					headers: {
						"Authorization": 'Bearer '+sessionStorage.token,
					},
					url: this.$build+'/api/store/'+sessionStorage.actShopId+'/currency',
				}).then(res => {
					console.log(res);
					if(res.data.status==200){
						this.currency = res.data.data.unit
					}else{
						for (var item in res.data.error) {
							this.$toast({
								type:'fail',
								message:res.data.error[item],
							});
						}
					}
				}).catch(err => {
					this.$toast({
						type:'fail',
						message:this.$t('EditDish.message'),
					});
				});
			},
			onClickLeft(){
				var item = this.prevData;
				if(this.prevData){
					this.$router.push({
						path:'WeekDetail',
						query:{week:item.period,startday:item.startday,endday:item.endday}
			        })
				}else{
					this.$toast({
						message:this.$t('NoData.noData'),
					});
				}
			},
			onClickRight(){
				var item = this.nextData;
				if(this.nextData){
					this.$router.push({
						path:'WeekDetail',
						query:{week:item.period,startday:item.startday,endday:item.endday}
			        })
				}else{
					this.$toast({
						message:this.$t('NoData.noData'),
					});
				}
			},
			// 导出报表
			onClickExport(){
				window.location.href = this.$build+'/api/store/'+sessionStorage.actShopId+'/exportReport?param=eachWeekIncome&startday='+this.$route.query.startday+'&endday='+this.$route.query.endday;
				// 类型：【totalMonthIncome：总月收入，eachMonthIncome：每月收入，eachDayIncome：每天收入，totalWeekIncome：总周收入，eachWeekIncome：每周收入】
			}
	  	}
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell__left-icon, .van-cell__right-icon{
		font-size: 22px;
	}
	/deep/ .weekBtn .van-nav-bar{background-color: #fff !important;color:#323233 !important;}
	/deep/ .weekBtn .van-nav-bar .van-icon{
		font-size: 22px;
		color: #969799;
	}
	/deep/ .van-nav-bar__text{color: #fff;}
	/deep/ .weekBtn .van-nav-bar__title,/deep/ .weekBtn .van-nav-bar__text{color: #323233!important;}
	.weekBtn{
		padding-top: 46px;
		background-color: #fff;
		width: 100%;
		padding-bottom: 15px;
	}
	.chartBox{
		width: 100%;
		min-height: 240px;
		background-color: #fff;
		/*padding-top: 46px;*/
	}
	.content{
		color: #000;
	}
</style>


// WEBPACK FOOTER //
// src/Report/WeekDetail.vue